import React from 'react';

const AndDidThoseFeet = () => {
  return (
    <div>
      <h1>“And did those feet…</h1>
      <iframe
        src="https://player.vimeo.com/video/333653451"
        width="640"
        height="360"
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
        title="And did those feet…"
      ></iframe>
      <p>By ‘Brooksy’ and Ted Baillieu</p>
      <p>
        As another winter approaches let us remember the Icebergers who have left
        us to swim… Lyrics by Ted Baillieu.
      </p>
      <p>
        And did those feet in ancient times
        <br />
        walk upon Brighton's bravest pier,
        <br />
        And did the holy speedo god
        <br />
        in Brighton's freezing water cheer,
        <br />
        And did his countenance bovine shine
        <br />
        forth upon those ageing crocks,
        <br />
        And was icebergery founded here
        <br />
        around these dark volcanic rocks,
        <br />
        Bring me my cap & rubber-hood,
        <br />
        Bring me my budgies of desire,
        <br />
        Bring me my gear, I'm feeling good,
        <br />
        Bring me the sauna and then fire,
        <br />
        I will not cease through wind or wave,
        <br />
        nor shall the cold hold any fear,
        <br />
        Till we have swum all temperatures
        <br />
        in Brighton's winter water clear.
      </p>
      <p>© Brighton Icebergers @ RBYC</p>
    </div>
  );
};

export default AndDidThoseFeet;
